<template>
  <div class="popup-wrapper">
    <DataLoader :is_on="updating" />
    <!-- <div class="entry-header-right"> -->
    <a @click="closePopup()" class="popup-close-icon-wrapper"><img src="@/assets/img/entry_form_close.svg" /></a>
    <!-- </div> -->
    <div class="popup-content-wrapper">
      <div class="vrste-evenata-wrapper">
        <div :class="'vrsta-eventa event-' + se.event_type.class_colour">
          {{ se.event_type.name }}
        </div>
        <div v-if="se.coordinates != null && se.coordinates.lat != -1" :class="'vrsta-eventa event-purple'">
          fizički
        </div>
        <div v-if="se.personal_event != undefined" :class="'vrsta-eventa event-green'">
          OSOBNI
        </div>
        <div v-if="se.case_id != null" :class="'vrsta-eventa event-grey'">
          PREDMETNI
        </div>
        <div v-if="se.project_id != null" :class="'vrsta-eventa event-pink'">
          PROJEKTNI
        </div>
      </div>
      <div class="title-edit-wrapper">
        <div class="kalendar-event-title">
          {{ se.title }}
        </div>
        <div v-if="!$store.state.rocista_tab_active && is_permission_inside('edit')"
          class="edit-case-name add-button add-pen" @click="goToForm()">
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
            <g>
              <g>
                <path fill="#7b7b8a"
                  d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
              </g>
            </g>
          </svg>
        </div>
        <div v-if="!$store.state.rocista_tab_active && is_permission_inside('delete')" class="delete-icon edit-case-name add-button add-pen"
          @click="delete_dialog = true">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z"
              fill="#70707E" />
          </svg>
        </div>
        <v-dialog v-model="delete_dialog" width="564px">
          <v-card color="universal-vcard">
            <div class="universal-vdialog-title">
              Jeste li sigurni da želite obrisati događaj?
            </div>
            <div class="vdialog-buttons-wrapper wrapper-three-buttons">
              <div class="universal-vdialog-button vbutton-secondary" @click="delete_dialog = false"> Odustani </div>
              <div class="universal-vdialog-button vbutton-primary" @click="deleteEvent()"> Obriši </div>
            </div>
          </v-card>
        </v-dialog>
      </div>

      <div class="vrijeme-lokacija-event">
        <div v-if="se.end_date_time != null" class="datum-event">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M14.3595 2.42254L14.3604 3.07846C16.7707 3.26737 18.3629 4.90979 18.3655 7.42853L18.375 14.8011C18.3784 17.5472 16.6532 19.2369 13.8878 19.2412L7.1329 19.25C4.38479 19.2535 2.63796 17.5236 2.63451 14.7696L2.62501 7.48363C2.62155 4.94828 4.15759 3.31022 6.5679 3.08896L6.56704 2.43303C6.56617 2.04823 6.85126 1.75875 7.23138 1.75875C7.61151 1.75787 7.8966 2.04648 7.89746 2.43129L7.89832 3.04348L13.03 3.03648L13.0291 2.42429C13.0282 2.03948 13.3133 1.75088 13.6934 1.75C14.0649 1.74913 14.3587 2.03773 14.3595 2.42254ZM3.95629 7.75387L17.0359 7.73638V7.43028C16.9988 5.54997 16.0554 4.56347 14.3621 4.41654L14.363 5.08995C14.363 5.46602 14.0701 5.76424 13.6986 5.76424C13.3185 5.76512 13.0326 5.46776 13.0326 5.0917L13.0317 4.38331L7.90005 4.3903L7.90091 5.09782C7.90091 5.47476 7.61669 5.77211 7.23657 5.77211C6.85645 5.77299 6.57049 5.47651 6.57049 5.09957L6.56963 4.42616C4.885 4.59495 3.95284 5.58496 3.95543 7.48188L3.95629 7.75387ZM13.3349 11.7288V11.7384C13.3436 12.1407 13.6718 12.4459 14.0701 12.4371C14.4589 12.4275 14.769 12.0943 14.7604 11.692C14.7422 11.3072 14.4304 10.9932 14.0425 10.9941C13.6451 11.0029 13.3341 11.3265 13.3349 11.7288ZM14.0485 15.6555C13.6511 15.6468 13.3306 15.3153 13.3297 14.913C13.3211 14.5107 13.6399 14.1775 14.0373 14.1679H14.0459C14.452 14.1679 14.7811 14.4994 14.7811 14.9104C14.782 15.3215 14.4537 15.6547 14.0485 15.6555ZM9.7756 11.7427C9.79288 12.145 10.122 12.459 10.5194 12.4415C10.9082 12.4232 11.2183 12.0908 11.2011 11.6885C11.1916 11.295 10.8719 10.9889 10.4831 10.9897C10.0857 11.0072 9.77474 11.3404 9.7756 11.7427ZM10.5229 15.6162C10.1255 15.6337 9.7972 15.3197 9.77906 14.9174C9.77906 14.5151 10.0892 14.1828 10.4866 14.1644C10.8754 14.1635 11.1959 14.4696 11.2045 14.8623C11.2227 15.2655 10.9116 15.5978 10.5229 15.6162ZM6.21629 11.7734C6.23357 12.1757 6.56272 12.4905 6.96012 12.4721C7.34888 12.4546 7.65902 12.1214 7.64088 11.7191C7.63224 11.3256 7.31259 11.0195 6.92297 11.0204C6.52557 11.0379 6.21542 11.3711 6.21629 11.7734ZM6.96357 15.6206C6.56617 15.6389 6.23788 15.3241 6.21974 14.9218C6.21888 14.5195 6.52989 14.1863 6.92729 14.1688C7.31605 14.1679 7.63656 14.474 7.6452 14.8676C7.66334 15.2699 7.35319 15.6031 6.96357 15.6206Z"
              fill="#55556A" />
          </svg>
          <div>{{ getDate(se.start_date_time) }}</div>
        </div>
        <div v-if="se.event_type.uid == 2 || se.event_type.uid == 3" class="vrijeme-event">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16">
            <g>
              <g>
                <path fill="#606076"
                  d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z" />
              </g>
            </g>
          </svg>
          <div>
            <div v-if="se.start_date_time != se.end_date_time">
              {{ getSatiEvent(se.start_date_time) }} -
              {{ getSatiEvent(se.end_date_time) }}
            </div>
            <div v-else>{{ getSatiEvent(se.start_date_time) }}</div>
          </div>
        </div>

      </div>
      <div v-if="se.location_address != null" class="lokacija-event">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
          <g>
            <g>
              <path fill="#606076"
                d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z" />
            </g>
          </g>
        </svg>
        <v-tooltip v-if="se.location_address.length >= 65" right>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
              {{ se.location_address.slice(0, 65) }}...
            </div>
          </template>
          <div class="flex-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
              <g>
                <g>
                  <path fill="#544EAC"
                    d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z" />
                </g>
              </g>
            </svg>
            {{ se.location_address }}
          </div>
        </v-tooltip>
        <div v-else>{{ se.location_address }}</div>
      </div>
      <div v-if="se.meeting_url != null && se.meeting_url != ''" class="lokacija-event">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
          <g>
            <g>
              <path fill="#606076"
                d="M11.314 7.843a2.465 2.465 0 0 1-2.463 2.462A2.465 2.465 0 0 1 6.39 7.843a2.465 2.465 0 0 1 2.462-2.464 2.466 2.466 0 0 1 2.463 2.464zM17 8.15c0 4.404-4.163 8.067-6.4 10.035-.31.274-.58.51-.793.71-.268.25-.612.375-.956.375-.343 0-.687-.125-.955-.375-.214-.2-.482-.436-.793-.71-2.237-1.968-6.4-5.63-6.4-10.035 0-2.177.848-4.223 2.387-5.763A8.094 8.094 0 0 1 8.85 0c2.177 0 4.223.848 5.762 2.387A8.098 8.098 0 0 1 17 8.15zm-4.558-.308c0-1.98-1.61-3.591-3.59-3.591A3.595 3.595 0 0 0 5.26 7.842c0 1.98 1.61 3.592 3.59 3.592 1.98 0 3.591-1.611 3.591-3.592z" />
            </g>
          </g>
        </svg>
        <a :href="se.meeting_url" target="_blank" class="underline-item">{{ se.meeting_url.length > 60 ?
            se.meeting_url.slice(0, 60) + '...' : se.meeting_url
        }}</a>
      </div>
      <!-- end vrijeme lokacija event -->
      <div v-if="se.location_name != null && se.location_name != ''" class="section-divider"></div>
      <div v-if="se.location_name != null && se.location_name != ''" class="sudionici-eventa">
        <div class="event-participants-wrapper">
          <div class="section-name">Pojedinosti</div>
          <div class="event-participants">
            <div class="opis-text">{{ se.location_name }}</div>
          </div>
        </div>
      </div>
      <!-- end event opis location -->
      <div v-if="se.event_lawyer_connector.length > 0">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Sudionici</div>
            <div class="event-participants align-participants">
              <a v-for="(partic, key) in se.event_lawyer_connector" :key="key" class="event-participant-popup"
                :href="'/osobe/law/' + partic.odvjetnik.uid">{{ partic.odvjetnik.ime }} {{ partic.odvjetnik.prezime
                }}</a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="se.spis != null && se.event_type.name == 'Ročište' && se.spis.spis_sudionici_connector != undefined && se.spis.spis_sudionici_connector.length != 0">
        <div class="section-divider"></div>
        <!-- end sudionici eventa -->
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Osobe postupka</div>
            <div class="event-participants align-participants">
              <div v-for="(partic, key) in se.spis.spis_sudionici_connector" :key="key">
                <a class="event-participant-popup"
                  :href="'/osobe/leg-body/' + partic.sluzbena_osoba.uid">{{ partic.sluzbena_osoba.ime }} {{
                      partic.sluzbena_osoba.prezime
                  }}</a> {{ partic.sluzbena_uloga.uloga_name != undefined &&
    partic.sluzbena_uloga.uloga_name != null ? '(' + partic.sluzbena_uloga.uloga_name + ')' : ''
}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="se.spis != null && se.event_type.name == 'Ročište' && se.spis.institucija != null && se.spis.institucija != undefined">
        <div class="section-divider"></div>
        <!-- end sudionici eventa -->
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Nadležno tijelo</div>
            <div class="event-participants align-participants">
              <a class="event-participant-popup"
                :href="'/osobe/institucije/' + se.spis.institucija.uid">{{ se.spis.institucija.naziv }}</a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="se.body != ''" class="section-divider"></div>
      <div v-if="se.body != ''" class="sudionici-eventa">
        <div class="event-participants-wrapper">
          <div class="section-name">Opis</div>
          <div class="event-participants">
            <div class="opis-text">{{ se.body }}</div>
          </div>
        </div>
      </div>
      <!-- end opis eventa -->
      <div v-if="se.personal_event == undefined && se.project_event == undefined && se.spis != null">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Vezani spis</div>
            <div class="event-participants">
              <a v-if="!$store.state.rocista_tab_active" :href="'/case/' + se.case_id + '/spisi/' + se.spis_id"
                class="opis-text underline-item">{{ se.spis.ime }}</a>
              <div class="opis-text status-text" v-else>{{ se.spis.ime }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="se.personal_event == undefined && se.project_id != undefined && se.project_id != null">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Projekt</div>
            <div class="event-participants">
              <a v-if="!$store.state.rocista_tab_active" :href="'/projects/' + se.project_id"
                class="opis-text underline-item">{{ se.project.name }}</a>
              <div class="opis-text status-text" v-else>{{ se.project.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="se.personal_event == undefined && se.case_id != undefined && se.case_id != null">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Predmet</div>
            <div class="event-participants">
              <a v-if="!$store.state.rocista_tab_active" :href="'/case/' + se.case_id"
                class="opis-text underline-item">{{ se.predmet.ime_predmeta }}</a>
              <div class="opis-text status-text" v-else>{{ se.predmet.ime_predmeta }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- end vezani spis eventa -->
      <div class="section-divider"></div>
      <div class="sudionici-eventa">
        <div class="event-participants-wrapper">
          <div class="section-name">Status</div>
          <div class="text-icon-wrapper">
            <div class="opis-text status-text">{{ se.planner_buckets_status.name }} </div>
            <div v-if="!$store.state.rocista_tab_active" class="task-checkbox-container">
              <!-- spinner koji se aktivira na klik i traje dok se ne izvrsi update -->
              <svg class="update-event-spin popup-event-spin" viewBox="0 0 50 50" style="display:none">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>

              <div :class="['custom-checkbox', 'popup-check', se.planner_buckets_status.id == 100 ? 'active' : '']"
                @click="handleCheckClick(se)">
                <div class="check"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-divider"></div>
      <div class="sudionici-eventa">
        <div class="event-participants-wrapper">
          <div class="section-name">Važnost</div>
          <div class="event-participants">
            <div class="opis-text"
              :style="se.event_importance.id == 'low' ? 'font-weight:700;color:green' : se.event_importance.id == 'normal' ? 'font-weight:700;color:#e19610' : 'font-weight:700;color:red'">
              {{ se.event_importance.naziv }}</div>
          </div>
        </div>
      </div>
      <div v-if="se.attachments != undefined && se.attachments != null && se.attachments.length > 0">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Privici</div>
            <div class="event-participants align-participants">
              <span v-for="(partic, key) in se.attachments" :key="key" class="event-attachment"
                @click="getAttachment(partic.id, se.graph_id)">{{ partic.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="se.attachment_urls != undefined && se.attachment_urls != null && se.attachment_urls.length > 0">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Privici</div>
            <div class="event-participants align-participants">
              <span v-for="(partic, key) in se.attachment_urls" :key="key" class="event-attachment"
                @click="getAttachmentNonPersonal(partic.id, partic.name)">{{ partic.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="se.subtasks != undefined && se.subtasks != null && se.subtasks.length > 0">
        <div class="section-divider"></div>
        <div class="sudionici-eventa">
          <div class="event-participants-wrapper">
            <div class="section-name">Podzadaci</div>
            <div class="event-participants align-participants">
              <div v-for="(partic, key) in se.subtasks" :key="key"
                :class="['subtask-row', partic.finished ? 'finished' : 'not-finished']">
                <svg v-if="partic.finished" xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8"
                  fill="none">
                  <path d="M1 4.32499L3.65936 6.98323L8.97585 1.66675" stroke="#9999A6" stroke-width="1.5"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg v-else style="margin: -7px -1px -7px -7px;" xmlns="http://www.w3.org/2000/svg" width="24"
                  height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M8.46409 15.5354L15.5352 8.46436" stroke="#9999A6" stroke-width="1.5"
                    stroke-linecap="round" />
                  <path d="M8.46409 8.46458L15.5352 15.5356" stroke="#9999A6" stroke-width="1.5"
                    stroke-linecap="round" />
                </svg>
                <span class="opis-text">{{ partic.task_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end popup wrapper -->
</template>

<script>
import $ from "jquery";
import gsap from "gsap";
import moment from "moment";
import auth from "@/services/auth";
import ms_calendar from "@/apiCallers/calendarSharepoint";
import DataLoader from '@/components/generalComponents/DataLoader'
import projCaller from "@/apiCallers/promise_handler_db/projects"
import permissioner from "@/services/permissioner.js"

export default {
  props: ["se"],
  data() {
    return {
      accessToken: "",
      delete_dialog: false,
      updating: false,
    }
  },
  components: {
    DataLoader,
  },
  methods: {
    am_i_inside() {
      return (this.se.event_lawyer_connector.filter(p=> p.odvjetnik.uid == this.$store.state.logged_in_user.uid).length>0)
    },
     is_permission_inside(wanted_permission) {
     return( permissioner.check_case_permsision("case.calendar.admin."+wanted_permission) || (permissioner.check_case_permsision("case.calendar."+wanted_permission)&&this.am_i_inside()))
    },
    case_permission_inside(wanted_permission)
    {
      return( permissioner.check_case_permsision("case.calendar.admin."+wanted_permission) || (permissioner.check_case_permsision("case.calendar."+wanted_permission)&&this.am_i_inside()))
    },
    async getAttachment(attach_id, event_id) {
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      await ms_calendar.getPersonalAttachment(this.accessToken, event_id, attach_id).then((resp) => {
        //pripremanje download linka
        var raw = window.atob(resp.data.contentBytes);
        var rawLength = raw.length;
        var array = new Uint8Array(new ArrayBuffer(rawLength));      // pass your byte response to this constructor

        for (var i = 0; i < rawLength; i++) {
          array[i] = raw.charCodeAt(i);
        }
        var newBlob = new Blob([array], {
          type: resp.data.contentType,
        });
        var data = window.URL.createObjectURL(newBlob);
        var link = document.createElement("a");
        link.href = data;
        link.download = resp.data.name;
        link.click();
      })
    },
    closePopup() {
      // var klasa = '.pop'+uid
      // var tl = new gsap.timeline()
      // gsap.to(".popup-wrapper",0.5,{opacity:0})
      // tl.to(klasa,0,{display:'none'})
      gsap.to(".popup-wrapper", 0.35, { opacity: 0 });
      gsap.to(".router-wrapper", 0, { pointerEvents: "auto" });
      gsap.to(".mainH", 0, { overflow: "auto" });
      if (!this.$store.state.notifies_shown) {
        gsap.to(".router-wrapper", 0.35, {
          filter: "none",
          opacity: 1,
        });
      }
      else {
        let tl = gsap.timeline();
        tl.to(".notifications-wrapper", 0, {
          display: "flex"
        });
        tl.to(".notifications-wrapper", 0.2, {
          opacity: 1,
        });
        this.$store.state.rocista_tab_active = false;
      }
      // this.$emit('popup_close');
      setTimeout(() => {
        this.$store.state.event_details.popup_open = false;
      }, 350);
    },
    async handleCheckClick() {
      //starting spinner
      gsap.to(
        ".popup-check",
        0,
        { display: "none", borderColor: "#0acab1" }
      );
      gsap.to(
        ".popup-event-spin",
        0.3,
        { display: "block" }
      );

      setTimeout(async () => {
        if (this.$store.state.event_details.chosen_event.planner_buckets_status.value != 100) {
          await ms_calendar.editEventBucketStatus(this.$store.state.event_details.chosen_event.uid, this.$store.state.event_details.chosen_event.personal_event != undefined ? 'personal' : 'case_event', 0).then((resp) => {
            this.$store.state.event_details.chosen_event.planner_buckets_status = resp.data.planner_buckets_status;
            //makni spinner
            gsap.to(
              ".popup-event-spin",
              0,
              { display: "none" }
            );
            //postavi checked
            gsap.to(
              ".popup-check",
              0.2,
              { display: "flex", border: "3px solid #c8f8f2" }
            );
            gsap.to(
              ".popup-check",
              0.4,
              { backgroundColor: "#0acab1" }
            );
          }).catch((err) => { });
        }
        else {
          await ms_calendar.editEventBucketStatus(this.$store.state.event_details.chosen_event.uid, this.$store.state.event_details.chosen_event.personal_event != undefined ? 'personal' : 'case_event', 100).then((resp) => {
            this.$store.state.event_details.chosen_event.planner_buckets_status = resp.data.planner_buckets_status;
            gsap.to(
              ".popup-check",
              0,
              { backgroundColor: "#fff" }
            );
            gsap.to(
              ".popup-event-spin",
              0,
              { display: "none" }
            );
            gsap.to(
              ".popup-check",
              0.2,
              { display: "flex", border: "4px solid #cccccc", backgroundColor: "#fff" }
            );
            setTimeout(() => {
              $(".popup-check").removeClass('active');
            }, 200);
          }).catch((err) => { });
        }
      }, 300);
    },
    goToForm() {
      gsap.to(".mainH", 0, { overflow: "auto" });
      this.$store.state.event_details.popup_open = false;
      console.log(this.$store.state.event_details);
      if (this.$store.state.event_details.chosen_event.personal_event != undefined && this.$store.state.event_details.chosen_event.personal_event) {
        this.$router.push("kalendar/novi-osobni-dogadaj/edit");
      } else {
        if (this.$store.state.event_details.chosen_event.project_id != null) {
          this.$router.push("/projects/" + this.$store.state.event_details.chosen_event.project_id + "/kalendar/edit");
        }
        else {
          this.$router.push("/case/" + this.$store.state.event_details.chosen_event.case_id + "/kalendar/edit");
        }
      }
    },
    async getAttachmentNonPersonal(attach_id, file_name) {
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      await projCaller.getTaskAttachment(this.accessToken, this.$store.state.event_details.chosen_event.case_id != null ? this.$store.state.event_details.chosen_event.case_id : this.$store.state.event_details.chosen_event.project_id, attach_id).then((resp) => {
        //pripremanje download linka
        var link = document.createElement("a");
        link.setAttribute("href", resp.data.webUrl);
        link.setAttribute("target", "_blank");
        link.setAttribute("download", file_name);
        link.click();
      })
    },
    getDate(date) {
      return moment(date).format("DD.MM.yyyy.");
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    async deleteEvent() {
      this.delete_dialog = false;
      this.updating = true;
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      await ms_calendar.deleteEvent(this.accessToken, this.se).then((resp) => {
        this.updating = false;
        this.$router.go()
      }).catch((err) => { this.updating = false });
    },
    deleteStyling() {
      setTimeout(function () {
        var upl = document.getElementById("delete-popup");
        $(upl.parentElement).addClass("delete-popup-wrapper");
      }, 100);
    }
  },
  mounted() {
    //close anim
    gsap.to(".mainH", 0.5, { overflow: "hidden" });
    gsap.to(".router-wrapper", 0.5, {
      filter: "blur(5px)",
      opacity: 0.2,
      pointerEvents: "none"
    });
    gsap.fromTo(
      ".popup-wrapper",
      0.5,
      { opacity: 0 },
      { zIndex: "999", opacity: 1 }
    );
    $(".popup-close-icon-wrapper").hover(
      function () {
        gsap.to($(this).find("img"), 0.3, {
          rotation: 180,
          transformOrigin: "center",
        });
      },
      function () {
        gsap.to($(this).find("img"), 0.5, {
          rotation: -180,
          transformOrigin: "center",
        });
      }
    );
    let _this = this;
    setTimeout(() => {
      $('.v-application').click(function (e) {
        let container = $(".popup-wrapper")
        let dialog = $(".v-dialog__content")
        if(!container.is(e.target) && container.has(e.target).length === 0 && !dialog.is(e.target) && dialog.has(e.target).length === 0) {
          _this.closePopup();
        }
      });
    }, 550);
  },
  beforeDestroy() {
    $('.v-application').off();
  },
  destroyed() {
    $(".popup-close-icon-wrapper").off();
  },
};
</script>

<style>
</style>